// extracted by mini-css-extract-plugin
export default {"itemWrapper":"Jzpto","item":"dEn1X","readOnlyItem":"VPZd4","itemText":"ZzHT5","itemImage":"Ac3ac","itemSuccess":"LNLFH","itemError":"v31K4","text":"C6DrD","img":"Z39Vj"};